import { useEffect } from "react";

const ModalVideo = ({ open, onClose }) => {
  useEffect(() => {
    let overlay = document.getElementById("overlay");
    let popup = document.getElementById("popup-youtube");
    const body = document.body;
    if (open) {
      overlay.style.display = "flex";
      popup.style.display = "block";
      body.style.overflow = "hidden";
    } else {
      overlay.style.display = "none";
      popup.style.display = "none";
      body.style.overflow = "auto";
    }
  }, [open]);
  return (
    <div className="popup-video">
      <div id="overlay" className="overlay" onClick={onClose}></div>
      <div className="popup" id="popup-youtube">
        <div className="content-popup">
          <iframe
            width="100%"
            height="500"
            src="https://www.youtube.com/embed/RwxXXqD2wCQ"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ModalVideo;
